import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { downloadDbBackup } from 'src/services/db';

const useDownloadBackup = () => {
  const { isLoading, mutateAsync, isError } = useMutation(() => downloadDbBackup());

  const downloadBackupMutation = async () => {
    console.log('Downloading backup...');
    try {
      const response = await mutateAsync();
      console.log("response",response)

      // Check if the response contains a file URL
      //@ts-ignore
      if (response?.file_url) {
        //@ts-ignore
        const fileUrl = response.file_url;

        // Create an anchor element to trigger the download
        const a = document.createElement('a');
        a.href = fileUrl;
        a.download = fileUrl.split('/').pop() || 'backup.sql'; // Extract filename or set default
        document.body.appendChild(a);
        a.click();

        // Clean up
        document.body.removeChild(a);
      } else {
        throw new Error('File URL not found in response');
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error.message || 'An error occurred while downloading the backup');
    }
  };

  return { isLoading, downloadBackupMutation, isError };
};

export default useDownloadBackup;
